import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, Route, RouteReuseStrategy } from '@angular/router';

@Injectable()
export class TabRouteReuseStrategy implements RouteReuseStrategy {
  readonly #handlers = new Map<Route | null, DetachedRouteHandle>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return route.data['reuse'] === true;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (!handle || route.data['reuse'] !== true) {
      return;
    }

    this.#handlers.set(this.#getRouteKey(route), handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return route.data['reuse'] === true && this.#handlers.has(this.#getRouteKey(route));
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (route.data['reuse'] !== true) {
      return null;
    }

    return this.#handlers.get(this.#getRouteKey(route)) ?? null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  #getRouteKey(route: ActivatedRouteSnapshot): Route | null {
    return route.routeConfig ?? null;
  }
}
